<template></template>
<script>
import MiniSearch from "minisearch"
import first from "rfuncs/functions/first"
import identity from "rfuncs/functions/identity"
import keys from "rfuncs/functions/keys"
import length from "rfuncs/functions/length"
import map from "rfuncs/functions/map"
import merge from "rfuncs/functions/merge"
import object_map from "rfuncs/functions/object_map"
import values from "rfuncs/functions/values"

import slugify from "../utils/slugify"

// abstract class needs to implement methods:
//
// filter_results
// default_results
//
// needs to implement props
//
// query

const create_search_index = (options, documents) => {
  const index = new MiniSearch(
    merge({ storeFields: keys(first(documents)) }, options)
  )

  index.addAll(documents)

  return index
}

export default {
  data() {
    return {
      debouncedQuery: "",
      searchTimeout: null,
      is_loading: true,
    }
  },
  watch: {
    query: {
      immediate: true,
      handler(q) {
        // Clear existing timeout
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout)
        }

        // Set debounced query after 300ms delay
        this.searchTimeout = setTimeout(() => {
          this.debouncedQuery = (q || "").trim()
          this.is_loading = false
        }, 250)
      },
    },
  },
  methods: {
    filter_results: identity,
  },
  computed: {
    index() {
      if (length(this.all_options)) {
        return create_search_index(
          {
            fields: ["unicode", "slug", "search_keys"],
            idField: "id",
            searchOptions: {
              boost: { unicode: 10, slug: 7, keys: 4 },
              fuzzy: 0.2,
              prefix: true,
            },
          },
          map(
            i => merge(i, { slug: slugify(i.unicode) }),
            values(this.all_options)
          )
        )
      }
      return null
    },
    results() {
      if (this.debouncedQuery && this.index)
        return object_map(
          v => v.id,
          identity,
          this.index.search(this.debouncedQuery)
        )
      return this.default_results || []
    },
  },
}
</script>
